import React from 'react';
import { Link } from 'gatsby';

import firstImage from './media/1.jpg';
import secondImage from './media/2.jpg';
import thirdImage from './media/3.jpg';
import faq from './media/faq.jpg';
import insta_mob from './media/instagram-mob.jpg';
import business_mob from './media/for-business-mob.jpg';
import coworking_mob from './media/coworking-mob.jpg';
import faq_mob from './media/faq-mob.jpg';

import './style.css';

/**
 * Компонент с рекламными блоками (сейчас скрыт).
 * @class
 * @memberof Home
 * @extends react-router-dom
 */
const Shop = () => (
    <div>
        <div className="shop d-m-none">
            <a href="https://www.instagram.com/moonceramic/" target="_blank" rel="noopener noreferrer">
                <div className="shop-container">
                    <img src={firstImage} alt="изображение магазина" />
                    <h5 className="shop__header">Инстаграм @moonceramic</h5>
                    <div className="shop__btn">Перейти</div>
                </div>
            </a>
            <div className="container-split">
                <div className="pages_item">
                    <Link to="/business">
                        <div className="shop-container shop-container_split">
                            <img src={secondImage} alt="изображение магазина" />
                            <h5 className="shop__header">Бизнесу.</h5>
                            <div className="shop__btn">Перейти</div>
                        </div>
                    </Link>
                </div>
                <div className="pages_item">
                    <Link to="/coworking">
                        <div className="shop-container shop-container_split">
                            <img src={thirdImage} alt="изображение магазина" />
                            <h5 className="shop__header">Коворкинг!</h5>
                            <div className="shop__btn">Перейти</div>
                        </div>
                    </Link>
                </div>
            </div>
            <Link to="/faq">
                <div className="shop-container shop-container_split">
                    <img src={faq} alt="изображение магазина" />
                    <h5 className="shop__header">Частые вопросы</h5>
                    <div className="shop__btn">Перейти</div>
                </div>
            </Link>
        </div>
        <div className="shop d-c-none">
            <div className="shop">
                <a href="https://www.instagram.com/moonceramic/" target="_blank" rel="noopener noreferrer">
                    <div className="shop-container">
                        <img src={insta_mob} alt="изображение магазина" />
                        <h5 className="shop__header">Инстаграм @moonceramic</h5>
                        <div className="shop__btn">Перейти</div>
                    </div>
                </a>
                <Link to="/business">
                    <div className="shop-container">
                        <img src={business_mob} alt="изображение магазина" />
                        <h5 className="shop__header">Бизнесу.</h5>
                        <div className="shop__btn">Перейти</div>
                    </div>
                </Link>
                <Link to="/coworking">
                    <div className="shop-container">
                        <img src={coworking_mob} alt="изображение магазина" />
                        <h5 className="shop__header">Коворкинг!</h5>
                        <div className="shop__btn">Перейти</div>
                    </div>
                </Link>
                <Link to="/faq">
                    <div className="shop-container">
                        <img src={faq_mob} alt="изображение магазина" />
                        <h5 className="shop__header">Частые вопросы</h5>
                        <div className="shop__btn">Перейти</div>
                    </div>
                </Link>
            </div>
        </div>
    </div>
);

export default Shop;